import { v4 as uuid } from 'uuid'
import { validationAlertWidth } from './constant'

const newNodeId = uuid()
export const newNode = {
  id: newNodeId,
  type: 'newNode',
  data: { id: newNodeId },
  position: { x: 100, y: 100 },
  width: 30,
  height: 30
}

export const resetNodeLayout = (nodes: any, edges: any) => {
  const startX = 100,
    startY = 100,
    gap = 80

  let currentMarginTop = 0,
    prevNodeWidth = 0,
    //prevNodeHeight = 0,
    prevX = startX

  function calculateX(prevX: number, widthDiff: number) {
    if (widthDiff < 0) {
      //prettier-ignore
      return prevX + ((widthDiff * -1) / 2)
    } else if (widthDiff > 0) {
      //prettier-ignore
      return prevX - (widthDiff / 2)
    } else {
      return prevX
    }
  }

  nodes.forEach((node: any, index: number) => {
    node.targetPosition = 'top'
    node.sourcePosition = 'bottom'
    const hasValidationComp = node.type !== 'newNode'
    const isTaskToolbarNode = node.type === 'taskToolbar'
    const nodeWidth = node.width || node.data.width,
      nodeHeight = node.height || node.data.height

    let currentX, currentY

    if (index === 0) {
      currentX = startX
      currentY = startY
    } else {
      const widthDiff = nodeWidth - prevNodeWidth
      currentX = hasValidationComp
        ? calculateX(prevX, widthDiff)
        : //prettier-ignore
          calculateX(prevX, widthDiff) + (validationAlertWidth / 2)
      currentY = gap + currentMarginTop
    }

    node.position = {
      x: isTaskToolbarNode ? node.position.x : currentX,
      y: isTaskToolbarNode ? node.position.y : currentY
    }

    prevX = currentX
    prevNodeWidth = nodeWidth
    //prevNodeHeight = nodeHeight
    currentMarginTop = currentY + nodeHeight

    return node
  })
  return { nodes, edges }
}

export const getUpdatedEdges = (nodes: any[]) => {
  const updatedEdges: any[] = []
  const updatedNodes = nodes.filter((item) => item.type !== 'taskToolbar')
  for (let i = 0; i < updatedNodes.length - 1; i++) {
    updatedEdges.push({
      id: uuid(),
      source: updatedNodes[i].id,
      target: updatedNodes[i + 1].id,
      type: updatedNodes[i + 1].type === 'newNode' ? 'step' : 'custom-edge'
    })
  }

  return updatedEdges
}

export const configTasks = async (nodes: any) => {
  let isValid = true
  const tasks: any = []

  const getConfig = (config: any, id: number, dimension: any) => {
    const getformattedData = (data: any, field: string) => {
      return data
        ?.map((d: any) => (field === 'filter' ? `${d.key}-${d.value}` : d.label))
        .join(', ')
    }
    return {
      id,
      team: config?.team?.label,
      databox: getformattedData(config?.databox, 'databox'),
      filter: getformattedData(config?.filters, 'filter'),
      dimension: { ...dimension }
    }
  }

  for (const index in nodes) {
    if (
      nodes[index].type !== 'newNode' &&
      nodes[index].type !== 'firstNode' &&
      nodes[index].type !== 'taskToolbar'
    ) {
      //prettier-ignore
      const executionOrder:number = parseInt(index + 1)
      if (nodes[index].type === 'smartDocs') {
        const config = nodes[index].config

        const databoxes = config?.databox?.map((databox: any) => databox.value)
        const questions = config?.prompts?.map((prompt: any) => prompt.value)
        const filters = config?.filters
        const isNodeValid = config?.onValidate ? await config?.onValidate() : true
        if (!isNodeValid) isValid = false
        const request = {
          teamIdentifier: config?.team?.value,
          databoxIdentifiers: databoxes,
          ...(config?.filters?.length > 0 && { filters: [filters] }),
          questions,
          config: getConfig(config, executionOrder, {
            width: nodes[index]?.width,
            height: nodes[index]?.height
          })
        }
        tasks.push({
          executionOrder,
          application: 'SmartDocs',
          task: 'qna',
          config: request.config,
          inputs: {
            request: JSON.stringify(request)
          }
        })
      } else if (nodes[index].type === 'smartData') {
        const config = nodes[index].config
        const isNodeValid = config?.onValidate ? await config?.onValidate() : true
        const selectedChartType = config?.chartType
        if (!isNodeValid || !selectedChartType.length) isValid = false
        const topicIdOrName = config?.chartTopicIdOrName
        const widgetId = config?.chartWidgetId
        const request = `topicIdOrName=${topicIdOrName}&chartId=${widgetId}`
        tasks.push({
          executionOrder,
          application: 'SmartData',
          task: 'chartdetails',
          inputs: {
            request
          }
        })
      }
    }
  }
  return {
    isValid,
    tasks
  }
}

export function isValidJSON(str: any) {
  try {
    JSON.parse(str)
    return true
  } catch (e) {
    return false
  }
}

export function getTaskCount(nodes: any) {
  return nodes.filter(
    (node: any) =>
      node.type !== 'newNode' && node.type !== 'firstNode' && node.type !== 'taskToolbar'
  ).length
}
